import axios from 'axios';
import { VIEW_API_BASE_URL } from '../../config';
import { IReviewListParams } from '../../pages/Review';
import { IApiResponse } from '../../services';
import { getApiToken } from '../../utils';
interface IGetReviewListResponse extends IApiResponse {
	totalCnt: number;
	period: IReviewItem[];
}

export interface IReviewItem {
	no: number;
	rvId: number;
	regDt: string;
	score: string;
	text: string;
	isReply: number;
	replyContents: string;
	isBlind: number;
	scoreClean: number;
	scoreFood: number;
	scoreService: number;
}

export interface IReplyReviewRequest {
	rvId: number;
	reply: string;
	replyRegId: string;
}

export interface IBlindRequest {
	rvId: number;
	blindReason: string;
	blindRegId: string;
}

// ajy 25.01.06
// api 구조 변경
export const getReviewList = (params: IReviewListParams) => {
	return new Promise((resolve: (response: IGetReviewListResponse) => void, reject: (e: Error) => void) => {
		axios({
			headers: {
				// 'book-token': '37fcf686-b9eb-4125-bd2f-cf83a643722b',
				'authoried-token': getApiToken(),
			},
			baseURL: VIEW_API_BASE_URL,
			url: '/api/review',
			method: 'GET',
			params,
		})
			.then((response) => resolve(response.data))
			.catch((e) => {
				const { response } = e;
				if (!response) {
					reject(e);
				} else {
					reject(response.data);
				}
			});
	});
};

// ajy 25.01.06
// api 구조 변경
export const replyReview = (data: IReplyReviewRequest) => {
	return new Promise((resolve: (response: any) => void, reject: (e: Error) => void) => {
		axios({
			headers: {
				// 'book-token': '37fcf686-b9eb-4125-bd2f-cf83a643722b',
				'authoried-token': getApiToken(),
			},
			baseURL: VIEW_API_BASE_URL,
			url: '/api/review/reply',
			method: 'PATCH',
			data,
		})
			.then((response) => resolve(response.data))
			.catch((e) => {
				const { response } = e;
				if (!response) {
					reject(e);
				} else {
					reject(response.data);
				}
			});
	});
};

// ajy 25.01.06
// api 구조 변경
export const requestBlind = (data: IBlindRequest) => {
	return new Promise((resolve: (response: any) => void, reject: (e: Error) => void) => {
		axios({
			headers: {
				// 'book-token': '37fcf686-b9eb-4125-bd2f-cf83a643722b',
				'authoried-token': getApiToken(),
			},
			baseURL: VIEW_API_BASE_URL,
			url: '/api/review/blind',
			method: 'PATCH',
			data,
		})
			.then((response) => resolve(response.data))
			.catch((e) => {
				const { response } = e;
				if (!response) {
					reject(e);
				} else {
					reject(response.data);
				}
			});
	});
};
